import script from "./DialogueModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogueModal.vue?vue&type=script&setup=true&lang=ts"

import "./DialogueModal.vue?vue&type=style&index=0&id=1dff7892&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dff7892"]])

export default __exports__